import { Checkbox } from '@/components/ui/checkbox';

type Props = {
  acknowledgements: readonly string[];
  accepted: string[];
  onChange: (values: string[]) => void;
  error?: string;
};

export default function AcknowledgementSection({ acknowledgements, accepted, onChange, error }: Props) {
  const toggle = (text: string) => {
    if (accepted.includes(text)) {
      onChange(accepted.filter((a) => a !== text));
    } else {
      onChange([...accepted, text]);
    }
  };

  const allAccepted = accepted.length === acknowledgements.length;

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Acknowledgements *</h2>
        <p className="text-xs text-muted-foreground">All acknowledgements are required</p>
      </div>
      {error && <p className="text-xs text-destructive">{error}</p>}
      <div className="space-y-3">
        {acknowledgements.map((text, i) => (
          <label
            key={i}
            className={`flex items-start gap-3 p-3 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
              accepted.includes(text)
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-primary/50'
            }`}
          >
            <Checkbox
              checked={accepted.includes(text)}
              onCheckedChange={() => toggle(text)}
              className="h-4 w-4 mt-0.5 shrink-0"
            />
            <span className="text-xs text-foreground leading-relaxed">{text}</span>
          </label>
        ))}
      </div>
      {!allAccepted && accepted.length > 0 && (
        <p className="text-xs text-muted-foreground">
          {accepted.length} of {acknowledgements.length} acknowledged
        </p>
      )}
    </div>
  );
}
